export const comicCategories = [
  { slug: 'korean-manhwa', name: '韩国漫画', icon: 'ri-global-line' },
  { slug: 'japanese-manga', name: '日本漫画', icon: 'ri-earth-line' },
  { slug: 'chinese-manhua', name: '国产漫画', icon: 'ri-map-pin-line' },
  { slug: 'bl-danmei', name: '耽美漫画', icon: 'ri-hearts-line' },
  { slug: 'fantasy', name: '玄幻漫画', icon: 'ri-magic-line' },
  { slug: 'romance', name: '恋爱漫画', icon: 'ri-heart-line' },
  { slug: 'action', name: '热血漫画', icon: 'ri-fire-line' },
  { slug: 'comedy', name: '搞笑漫画', icon: 'ri-emotion-laugh-line' },
  { slug: 'horror', name: '悬疑漫画', icon: 'ri-ghost-line' },
  { slug: 'slice-of-life', name: '日常漫画', icon: 'ri-sun-line' },
];

export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  categoryName: string;
  cover: string;
  description: string;
  status: '连载中' | '已完结';
  rating: number;
  chapters: ComicChapter[];
  tags: string[];
  views: number;
  updatedAt: string;
}

const generateChapters = (comicId: string, count: number): ComicChapter[] => {
  const chapters: ComicChapter[] = [];
  for (let i = count; i >= 1; i--) {
    const date = new Date(2026, 6, 1 - i);
    chapters.push({
      id: `${comicId}-ch-${i}`,
      title: `第${i}话`,
      number: i,
      updatedAt: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`,
    });
  }
  return chapters;
};

export const comics: Comic[] = [
  {
    id: 'comic-001',
    title: '首尔的秘密',
    author: '金秀雅',
    category: 'korean-manhwa',
    categoryName: '韩国漫画',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20romantic%20drama%20scene%20with%20elegant%20characters%20in%20Seoul%20cityscape%20background%2C%20soft%20warm%20lighting%2C%20webtoon%20art%20style%2C%20clean%20composition%20with%20pastel%20color%20palette%2C%20minimal%20background%20with%20subtle%20gradients&width=600&height=800&seq=comic-cover-001&orientation=portrait',
    description: '在繁华的首尔都市，两个来自不同世界的人因为一次偶然的相遇而展开了一段动人的故事。他是一名成功的建筑师，她是咖啡店的老板，命运的红线将他们紧紧相连。但家庭的反对和过去的阴影，让这段感情充满了波折。他们能否战胜一切阻碍，找到属于自己的幸福？',
    status: '连载中',
    rating: 9.2,
    chapters: generateChapters('comic-001', 87),
    tags: ['恋爱', '都市', '剧情'],
    views: 1285000,
    updatedAt: '2026-08-02',
  },
  {
    id: 'comic-002',
    title: '剑与魔法学院',
    author: '李明宇',
    category: 'fantasy',
    categoryName: '玄幻漫画',
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20manhwa%20style%20illustration%20of%20a%20magical%20academy%20scene%20with%20young%20hero%20wielding%20a%20sword%2C%20mystical%20auras%20and%20spell%20effects%2C%20webtoon%20art%20style%2C%20epic%20adventure%20mood%2C%20warm%20golden%20and%20emerald%20color%20palette%2C%20clean%20simple%20background&width=600&height=800&seq=comic-cover-002&orientation=portrait',
    description: '在一个剑与魔法并存的世界，少年艾伦意外获得了传说中的「圣剑之魂」，被皇家魔法学院破格录取。在这里，他遇到了各种各样的伙伴和对手，逐渐揭开了自己身世之谜。一场关乎世界命运的冒险，就此展开！',
    status: '连载中',
    rating: 9.5,
    chapters: generateChapters('comic-002', 120),
    tags: ['奇幻', '冒险', '学院', '热血'],
    views: 2560000,
    updatedAt: '2026-08-03',
  },
  {
    id: 'comic-003',
    title: '与你相遇的春天',
    author: '朴智恩',
    category: 'romance',
    categoryName: '恋爱漫画',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20manhwa%20illustration%20of%20a%20couple%20under%20cherry%20blossom%20trees%20in%20spring%2C%20soft%20pink%20and%20white%20color%20palette%2C%20gentle%20and%20heartwarming%20mood%2C%20webtoon%20art%20style%2C%20clean%20minimal%20background%20with%20cherry%20blossom%20petals%2C%20elegant%20character%20design&width=600&height=800&seq=comic-cover-003&orientation=portrait',
    description: '高中最后一年，转学生智秀遇到了温柔的同桌敏俊。春天的樱花树下，他们许下了青涩的约定。然而大学的选择、家庭的变故，让两人不得不面临分离。多年后，当他们再次相遇，那份埋藏在心底的感情，是否还能重新绽放？',
    status: '已完结',
    rating: 9.1,
    chapters: generateChapters('comic-003', 64),
    tags: ['恋爱', '校园', '治愈'],
    views: 1890000,
    updatedAt: '2026-06-15',
  },
  {
    id: 'comic-004',
    title: '暗夜追踪者',
    author: '佐藤健太',
    category: 'horror',
    categoryName: '悬疑漫画',
    cover: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20manhwa%20style%20illustration%20with%20a%20detective%20character%20in%20dark%20urban%20alley%2C%20dramatic%20lighting%20and%20shadows%2C%20noir%20atmosphere%2C%20webtoon%20art%20style%2C%20dark%20grays%20and%20crimson%20accents%2C%20clean%20background%20with%20mysterious%20mood&width=600&height=800&seq=comic-cover-004&orientation=portrait',
    description: '刑警韩志勋接手了一起连环失踪案，看似普通的案件背后，却隐藏着一个惊天阴谋。每一条线索都将调查引向更深邃的黑暗。当真相逐渐浮出水面，他发现凶手可能就在身边。一部让人屏息的悬疑力作！',
    status: '连载中',
    rating: 9.4,
    chapters: generateChapters('comic-004', 45),
    tags: ['悬疑', '推理', '犯罪'],
    views: 967000,
    updatedAt: '2026-08-01',
  },
  {
    id: 'comic-005',
    title: '星辰大海',
    author: '陈晓峰',
    category: 'chinese-manhua',
    categoryName: '国产漫画',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20sci-fi%20illustration%20of%20a%20young%20astronaut%20gazing%20at%20distant%20galaxies%2C%20cosmic%20nebula%20colors%2C%20epic%20scale%2C%20webtoon%20art%20style%2C%20deep%20space%20purple%20and%20blue%20tones%2C%20clean%20composition%20with%20starry%20background&width=600&height=800&seq=comic-cover-005&orientation=portrait',
    description: '公元2245年，人类已经进入星际时代。年轻的飞船驾驶员叶星辰在执行一次普通运输任务时，意外发现了失落的古代文明遗迹。这个发现将改变人类对宇宙的认知，也让她被卷入了一场跨越星系的巨大阴谋之中。',
    status: '连载中',
    rating: 9.0,
    chapters: generateChapters('comic-005', 78),
    tags: ['科幻', '冒险', '热血'],
    views: 1340000,
    updatedAt: '2026-07-30',
  },
  {
    id: 'comic-006',
    title: '樱花庄的日常',
    author: '田中花子',
    category: 'slice-of-life',
    categoryName: '日常漫画',
    cover: 'https://readdy.ai/api/search-image?query=Slice%20of%20life%20manhwa%20illustration%20of%20friends%20gathered%20in%20a%20cozy%20apartment%20with%20plants%20and%20pet%20cat%2C%20warm%20sunlight%20through%20window%2C%20relaxing%20and%20heartwarming%20mood%2C%20webtoon%20art%20style%2C%20soft%20warm%20neutral%20color%20palette%2C%20clean%20minimal%20background&width=600&height=800&seq=comic-cover-006&orientation=portrait',
    description: '四个性格迥异的女生合住在一栋名为「樱花庄」的老公寓里，她们一起面对生活中的点点滴滴——考试、恋爱、工作、梦想。温馨搞笑的日常，让人感受到友情的力量和生活的美好。',
    status: '已完结',
    rating: 8.9,
    chapters: generateChapters('comic-006', 96),
    tags: ['日常', '搞笑', '友情', '治愈'],
    views: 756000,
    updatedAt: '2026-05-20',
  },
  {
    id: 'comic-007',
    title: '血族伯爵',
    author: '维罗妮卡',
    category: 'bl-danmei',
    categoryName: '耽美漫画',
    cover: 'https://readdy.ai/api/search-image?query=Gothic%20vampire%20manhwa%20style%20illustration%20of%20two%20elegant%20male%20characters%20in%20victorian%20attire%2C%20romantic%20and%20mysterious%20atmosphere%2C%20dramatic%20moonlight%20lighting%2C%20webtoon%20art%20style%2C%20deep%20burgundy%20and%20golds%2C%20clean%20dark%20background&width=600&height=800&seq=comic-cover-007&orientation=portrait',
    description: '十九世纪的欧洲，年轻的画家艾德里安偶然救下了一位神秘的贵族男子，却不知对方正是传说中的血族伯爵。在朝夕相处中，两人之间产生了超越种族的感情。但血族的诅咒和猎人的追杀，让这段禁忌之恋充满了危险。',
    status: '连载中',
    rating: 9.3,
    chapters: generateChapters('comic-007', 56),
    tags: ['耽美', '奇幻', '剧情'],
    views: 2100000,
    updatedAt: '2026-08-03',
  },
  {
    id: 'comic-008',
    title: '一拳超人传',
    author: '王大锤',
    category: 'comedy',
    categoryName: '搞笑漫画',
    cover: 'https://readdy.ai/api/search-image?query=Comedy%20action%20manhwa%20illustration%20of%20a%20bald%20superhero%20with%20exaggerated%20expression%20defeating%20monsters%2C%20dynamic%20action%20pose%2C%20humorous%20and%20energetic%20mood%2C%20webtoon%20art%20style%2C%20bright%20yellow%20and%20orange%20color%20palette%2C%20clean%20simple%20background&width=600&height=800&seq=comic-cover-008&orientation=portrait',
    description: '普通人张伟因一次意外获得了无敌的力量——一拳就能解决任何对手。从此他开始了超级英雄的生活，却发现自己最大的敌人不是怪物，而是生活中的各种囧事。搞笑热血，笑到停不下来！',
    status: '连载中',
    rating: 9.0,
    chapters: generateChapters('comic-008', 112),
    tags: ['搞笑', '热血', '超级英雄'],
    views: 3230000,
    updatedAt: '2026-08-02',
  },
  {
    id: 'comic-009',
    title: '东京食梦者',
    author: '山田太郎',
    category: 'japanese-manga',
    categoryName: '日本漫画',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20dark%20fantasy%20illustration%20of%20a%20teenager%20with%20supernatural%20ability%20in%20modern%20Tokyo%2C%20dramatic%20action%20scene%2C%20intense%20and%20stylish%20art%2C%20webtoon%20manga%20fusion%20style%2C%20darker%20tone%20with%20vibrant%20accents%2C%20clean%20urban%20night%20background&width=600&height=800&seq=comic-cover-009&orientation=portrait',
    description: '高中生黑崎翔拥有进入他人梦境的能力，他利用这个能力帮助人们解决心理问题。但当他进入一个神秘少女的梦境时，却发现了一个与现实世界交织的黑暗秘密。梦境与现实、善良与邪恶的边界逐渐模糊。',
    status: '连载中',
    rating: 9.4,
    chapters: generateChapters('comic-009', 90),
    tags: ['奇幻', '少年', '剧情'],
    views: 1780000,
    updatedAt: '2026-08-01',
  },
  {
    id: 'comic-010',
    title: '格斗天王',
    author: '雷克斯',
    category: 'action',
    categoryName: '热血漫画',
    cover: 'https://readdy.ai/api/search-image?query=Action%20martial%20arts%20manhwa%20illustration%20of%20a%20fighter%20in%20dynamic%20combat%20pose%20inside%20an%20arena%2C%20intense%20dramatic%20lighting%2C%20muscular%20character%20design%2C%20webtoon%20art%20style%2C%20fiery%20orange%20and%20bold%20red%20color%20palette%2C%20clean%20arena%20background&width=600&height=800&seq=comic-cover-010&orientation=portrait',
    description: '地下格斗界的传奇拳手林峰，为了给妹妹筹集医药费重返擂台。每一场战斗都是生与死的较量，每一个对手都有自己的故事。在热血与汗水中，他用拳头守护着最重要的人。燃到爆的热血格斗漫画！',
    status: '连载中',
    rating: 9.1,
    chapters: generateChapters('comic-010', 68),
    tags: ['格斗', '热血', '励志'],
    views: 1450000,
    updatedAt: '2026-07-28',
  },
  {
    id: 'comic-011',
    title: '总裁的替身新娘',
    author: '林婉儿',
    category: 'romance',
    categoryName: '恋爱漫画',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20manhwa%20illustration%20of%20a%20beautiful%20woman%20in%20wedding%20dress%20with%20a%20cold%20male%20CEO%20in%20modern%20luxury%20setting%2C%20dramatic%20and%20emotional%20atmosphere%2C%20webtoon%20art%20style%2C%20rose%20gold%20and%20cream%20color%20palette%2C%20clean%20elegant%20background&width=600&height=800&seq=comic-cover-011&orientation=portrait',
    description: '为了救弟弟的命，苏小曼代替姐姐嫁给传说中冷酷无情的总裁陆景辰。她以为这是一场交易，却没想到在朝夕相处中，两人之间的感情悄然萌芽。但当姐姐突然回来，这场替身婚约又将何去何从？',
    status: '连载中',
    rating: 8.8,
    chapters: generateChapters('comic-011', 103),
    tags: ['恋爱', '都市', '总裁'],
    views: 4580000,
    updatedAt: '2026-08-03',
  },
  {
    id: 'comic-012',
    title: '妖怪公寓',
    author: '乌鸦',
    category: 'fantasy',
    categoryName: '玄幻漫画',
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20supernatural%20manhwa%20illustration%20of%20a%20young%20man%20surrounded%20by%20mythical%20creatures%20in%20a%20traditional%20Asian%20apartment%2C%20whimsical%20and%20magical%20atmosphere%2C%20webtoon%20art%20style%2C%20rich%20earthy%20greens%20and%20warm%20amber%20colors%2C%20clean%20detailed%20background&width=600&height=800&seq=comic-cover-012&orientation=portrait',
    description: '大学生陈默为了省房租住进了一栋破旧的公寓，却意外发现这里的邻居都不是人类——狐仙、蛇妖、猫又……从此他的日常变得鸡飞狗跳。一部融合了中国传统妖怪文化的奇幻搞笑漫画！',
    status: '连载中',
    rating: 9.2,
    chapters: generateChapters('comic-012', 74),
    tags: ['奇幻', '搞笑', '妖怪', '国产'],
    views: 1980000,
    updatedAt: '2026-07-29',
  },
];

export const featuredComicIds = ['comic-001', 'comic-011', 'comic-002', 'comic-007', 'comic-009'];

export const latestUpdateIds = ['comic-011', 'comic-002', 'comic-007', 'comic-001', 'comic-008', 'comic-004', 'comic-009', 'comic-012'];

export const popularComicIds = ['comic-011', 'comic-008', 'comic-002', 'comic-007', 'comic-001', 'comic-012', 'comic-003', 'comic-010'];

export interface Testimonial {
  id: string;
  name: string;
  avatar: string;
  content: string;
  rating: number;
  date: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 't-001',
    name: '漫画爱好者小王',
    avatar: '',
    content: '汗汗漫画真的太棒了！资源超全，更新速度也很快，我的每天必刷网站。特别喜欢韩国漫画的分类，能找到很多冷门好作品。',
    rating: 5,
    date: '2026-07-20',
  },
  {
    id: 't-002',
    name: '资深漫迷小李',
    avatar: '',
    content: '用了三年了，见证了汗汗漫画的成长。界面越来越好看，分类越来越清晰。推荐给了很多朋友，大家都是忠粉！',
    rating: 5,
    date: '2026-07-15',
  },
  {
    id: 't-003',
    name: '漫画小仙女',
    avatar: '',
    content: '耽美漫画的分类做得特别好，更新频率也很高。而且没有乱七八糟的广告弹窗，阅读体验非常舒适。给汗汗漫画点赞！',
    rating: 4,
    date: '2026-07-10',
  },
  {
    id: 't-004',
    name: '热血少年阿杰',
    avatar: '',
    content: '热血漫画爱好者必来！格斗天王、剑与魔法学院都是我一直追的，更新稳定画质清晰。虫虫漫画的入口也很方便，无缝切换。',
    rating: 5,
    date: '2026-07-08',
  },
  {
    id: 't-005',
    name: '漫画控小张',
    avatar: '',
    content: '汗汗漫画官网的资源互联互通做得很好，虫虫漫画免费漫画入口也很顺畅。想看什么类型都能找到，强烈推荐！',
    rating: 5,
    date: '2026-07-05',
  },
  {
    id: 't-006',
    name: '追漫少女小美',
    avatar: '',
    content: '每天都在汗汗漫画看更新，总裁的替身新娘太上头了！画风精美剧情紧凑，希望平台越来越好，推出更多优秀的韩国漫画。',
    rating: 5,
    date: '2026-07-01',
  },
];

export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    id: 'faq-001',
    question: '汗汗漫画是什么？',
    answer: '汗汗漫画是一个专注于漫画阅读的在线平台，提供韩国漫画、日本漫画、国产漫画等丰富资源。我们致力于为漫画爱好者提供最优质的阅读体验，并设有虫虫漫画等免费漫画弹窗入口，实现资源互联互通。',
  },
  {
    id: 'faq-002',
    question: '汗汗漫画是否需要付费？',
    answer: '汗汗漫画提供大量免费漫画资源，用户可以直接在线免费阅读。部分独家内容可能需要会员支持，我们会持续为免费用户提供丰富的漫画选择。',
  },
  {
    id: 'faq-003',
    question: '如何通过汗汗漫画进入虫虫漫画？',
    answer: '汗汗漫画官网设有虫虫漫画免费漫画弹窗入口，您可以在网站首页或导航栏找到相关入口按钮，点击即可跳转至虫虫漫画，实现不同漫画平台间的自由切换。',
  },
  {
    id: 'faq-004',
    question: '漫画更新频率如何？',
    answer: '我们与多家漫画平台保持密切合作，热门漫画一般在发布后24小时内更新。韩国漫画和国产漫画的更新速度尤其快，确保读者能第一时间看到最新内容。',
  },
  {
    id: 'faq-005',
    question: '支持哪些设备阅读？',
    answer: '汗汗漫画支持电脑、平板和手机等多种设备访问。网站采用响应式设计，在不同屏幕尺寸下都能提供流畅的阅读体验。',
  },
  {
    id: 'faq-006',
    question: '如何找到想看的漫画？',
    answer: '您可以通过首页的分类导航浏览不同类型的漫画，也可以使用搜索功能直接查找。我们还提供热门推荐和最新更新列表，帮助您发现更多好漫画。',
  },
];